/**
 * 当前登陆人角色类型
 */
/** 主接口人 */
export const ROLE_TYPE_MAIN = 1;
/** 普通接口人 */
export const ROLE_TYPE_COMMON = 2;
/** 二级商主接口人 */
export const ROLE_TYPE_SEC_SUPPLIER = 3;
/** 招募管理角色人 */
export const ROLE_TYPE_ZHAOPIN = 4;

export default [
    {
        text: '劳动力首页',
        icon: 'icon-home1',
        url: '/renxiao/index',
        children: [],
    },
    {
        text: '供应商发薪信息管理',
        icon: 'icon-contactperson',
        url: '/renxiao/payMethod/management',
        roles: [ROLE_TYPE_MAIN, ROLE_TYPE_SEC_SUPPLIER],
        children: [],
    },
    {
        text: '供应商接口人管理',
        icon: 'icon-contactperson',
        url: '/renxiao/liaisonOfficerManagment',
        roles: [ROLE_TYPE_MAIN],
        children: [],
    },
    {
        text: '员工发薪账户信息提报',
        icon: 'icon-contactperson',
        url: '/renxiao/memberBankAccount',
        roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
        children: [],
    },
    {
        text: '结薪账单',
        icon: 'icon-contactperson',
        url: '/renxiao/salarySettlementBill/list',
        roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
        children: [],
    },
    {
        text: '工资单',
        icon: 'icon-contactperson',
        url: '/renxiao/salaryPayrolls',
        roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
        children: [],
    },
    {
        text: '税费扣款',
        icon: 'icon-contactperson',
        roles: [ROLE_TYPE_MAIN, ROLE_TYPE_COMMON],
        children: [
            {
                text: '上传调整',
                url: '/renxiao/manual/import',
            },
            {
                text: '已导入查询',
                url: '/renxiao/manual/list',
            },
        ],
    },
    /* {
        text: '供应商钱袋宝注册',
        icon: 'icon-contactperson',
        url: '/renxiao/secSupplierSalary',
        roles: [],
        children: [],
    }, */
    {
        text: '供应商保险管理',
        url: '/renxiao/insuranceManagement',
        roles: [ROLE_TYPE_MAIN],
        icon: 'el-icon-search',
        children: [],
    },
    {
        text: '供应商招募管理',
        icon: 'icon-contactperson',
        url: '/renxiao/recruitManagement',
        roles: [ROLE_TYPE_ZHAOPIN],
        children: [],
    },
];
